import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { AuthScreen } from "./components/AuthScreen";
import { useMe } from "./query/auth";
import { queryClient } from "./query/queryClient";
import { router } from "./router";
import { useAuthStore } from "./store/auth";

// Гейт сессии — порт startup/enterApp/showAuth (app-pages.js):
//   нет токена → экран входа; есть токен, нет user → грузим /api/me; ошибка /api/me → вход (как legacy fallthrough к showAuth).
// body.authed гейтит видимость shell/auth-экрана в style.css — синхронизируем классом.
function AuthGate() {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const me = useMe();

  useEffect(() => {
    if (me.data) setUser(me.data);
  }, [me.data, setUser]);

  const authed = !!token && !!user;
  useEffect(() => {
    document.body.classList.toggle("authed", authed);
  }, [authed]);

  if (!token) return <AuthScreen />;
  if (!user) {
    if (me.isError) return <AuthScreen />;
    return (
      <div className="auth-screen">
        <div className="auth-card" style={{ textAlign: "center" }}>
          <span className="spin" /> Загрузка…
        </div>
      </div>
    );
  }
  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthGate />
    </QueryClientProvider>
  );
}
